const zh_HK = {
    //ALL
    "360 Degrees Camera System for Coastal": "海岸360相機系統",
    "Program": "系統",
    "Map": "地圖",
    "Record Detail": "相片紀錄",
    "Summary": "相機資料",
    "Account": "使用者管理",
    "Photo": "相片",
    "From Date": "開始時間",
    "To Date": "完結時間",
    "Area": "地域",
    "District": "地區",
    "Name": "地點名字",
    "Station Name":"地點名字",
    "No Latest Photo":"沒有最新相片",
    "ALL": "全部",
    "Search": "搜尋",
    "Reset":"重置",
    "Add": "新增",
    "Edit": "編輯",
    "Save": "儲存",
    "Back": "返回",
    "Select File": "選擇檔案",
    "Date": "日期",
    "Time": "時間",
    "Logout": "登出",
    "Hello, ": "您好, ",
    "Create": "新增",
    "Delete": "刪除",
    "Create Date": "新增日期",
    "Location": "地點",
    "Status": "狀態",
    "Start Time": "開始時間",
    "End Time": "結束時間",
    "Coordinates: ": "座標: ",
    //Login
    "Login": "登入",
    "Email:": "電郵",
    "Password:": "密碼",
    "Forgot Password?": "忘記密碼?",
    "QR Code": "二維碼",
    "Report": "報告",
    "Maintenance Record":"維護紀錄",
    "Maintenance Date":"維護時間",
    "Maintenance From Date":"維護開始時間",
    "Maintenance To Date":"維護結束時間",
    "Select Maintenance From Date":"選擇維護開始時間",
    "Select Maintenance To Date":"選擇維護結束時間",
    "ToDateBeforeFromDateError":"完結時間不能早於開始日期",
    "Battery Level":"電量",
    "MarkerContent":"這是 {{place}} 標記",
    "Previous":"上一頁",
    "Title":"標題",
    "Detail":"詳細",
    "Upload Attachments (Multiple allowed)":"上載檔案(可多選)",
    "Drag & drop files here, or click to select": "將檔案拖放到此處，或按一下選擇",
    "Select Date & Time": "選擇日期和時間",
    "Description":"描述",
    "Add Maintenance Record":"新增維護記錄",
    "Submit":"提交",
    "Cancel":"取消",
    "ID":"編號",
    "Station ID":"相機編號",
    "Attachments":"檔案",
    "No attachments available":"沒有檔案",
    "Unknown":"不明",
    "Perspective Photo":"投影相片",
    "Latest Photo Record":"最新相片記錄",
    "Battery Voltage":"電池電壓",
    "Staff":"員工",
    "Loading panorama":"正在載入全景圖",
    "360° Photo": "全景圖",
    "Error":"錯誤",
    "An error occurred. Please login again.":"發生錯誤。請重新登入。",
    "Failed to load panorama image":"全景圖載入失敗",
    "Username":"名字",
    "Email":"電郵",
    "Role":"權限",
    "Phone Number":"電話",
    "Active":"啓用",
    "UpdatedBy":"修改人",
    "Updated Date":"修改日期",
    "Password":"密碼",
    "User Management":"使用者管理",
    "Create user":"新增使用者",
    "Email/Username":"電郵/帳號",
    "Download Report":"下載每月報告",
    "Month":"月份",
    "Action":"操作",
    "Download":"下載",
    "Detail Report":"詳細報告",
    "Summary Report":"摘要報告",
    "Statistics Report":"統計報告",
    "Last Update Time": "最後更新時間",
    "To Date cannot be earlier than From Date": "完結時間不能早於開始日期"
    //Location Translation
}

export default zh_HK;